import { Site, SiteStatusEnum } from 'types/site';
import * as yup from 'yup';

export const getInitialValues = (site?: Site | null) => ({
  name: site?.name || '',
  address: site?.address || {
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    zip: '',
  },
  packages: site?.packages || [],
  portal: typeof site?.portal === 'boolean' ? site?.portal : false,
  portalName: site?.portalName || '',
  banner: site?.banner || '',
  logo: site?.logo || '',
  isSuspended: site?.isSuspended || false,
  operator: site?.operator || null,
  admin: site?.admin || '',
  deliveryFrequency: site?.deliveryFrequency || '',
  deliveryDayOfTheWeek: site?.deliveryDayOfTheWeek || [],
  deliveryInstructions: site?.deliveryInstructions || '',
  pickupInstructions: site?.pickupInstructions || '',
  siteType: site?.siteType || '',
  capacity: site?.capacity || '',
  // invoice per delivery
  invoice: typeof site?.invoice === 'boolean' ? site?.invoice : undefined,
  invoicePerPickup:
    typeof site?.invoicePerPickup === 'boolean'
      ? site?.invoicePerPickup
      : undefined,
  contract: site?.contract || '',
  contractDate: site?.contractDate || null,
  invoiceNotes: site?.invoiceNotes || '',
  billingDetails: site?.billingDetails || '',
  pricingDetails: site?.pricingDetails || [],
  hasExpirationDate:
    typeof site?.hasExpirationDate === 'boolean'
      ? site?.hasExpirationDate
      : undefined,
  hasCokeAdjustment:
    typeof site?.hasCokeAdjustment === 'boolean'
      ? site?.hasCokeAdjustment
      : undefined,
  website: site?.website || '',
  qrLandingUrl: site?.qrLandingUrl || '',
  accountManagers: (site as any)?.accountManagers || [],
  // using this for disabling the submit button when image is being uploaded
  _isUploading: false,
  isArchived: site?.status === SiteStatusEnum.ARCHIVED,
});

export const validationSchema = yup.object().shape({
  name: yup.string().required('Name is a required field'),
  washHub: yup.string(),
  address: yup.object().required('Address is required'),
  admin: yup.string(),
  deliveryFrequency: yup.string().required('Delivery frequency is required'),
  deliveryDayOfTheWeek: yup.array(),
  deliveryInstructions: yup.string(),
  pickupInstructions: yup.string().max(1000),
  siteType: yup.string(),
  capacity: yup.string(),
  portal: yup.boolean(),
  portalName: yup.string().when('portal', {
    is: true,
    then: yup.string().required('Portal name is required'),
  }),
  banner: yup.string(),
  logo: yup.string(),
  accountManagers: yup.array(),
  invoice: yup.boolean().required('Invoice status is required'),
  invoicePerPickup: yup.boolean().required('Invoice per pickup is required'),
  hasExpirationDate: yup.boolean(),
  hasCokeAdjustment: yup.boolean().required('Coke Adjustment is required'),
  contract: yup.string(),
  contractDate: yup
    .date()
    .nullable(true)
    .when('hasExpirationDate', {
      is: true,
      then: yup.date().nullable().required('Contract date is required'),
      otherwise: yup.date().nullable(true),
    }),
  isArchived: yup.boolean(),
});
